module.exports = __webpack_public_path__ + "img/txt_info4.546909a4.png";